<script setup lang="ts">
import {
    BUNDLE_CAMPAIGN_DESCRIPTION,
    BUNDLE_CAMPAIGN_HEADLINE,
    BUNDLE_CAMPAIGN_LEGAL_TEXT,
} from '@b2b-platform/commerce/texts/bundle-campaign';

const { showBundleCampaign } = useBundleCampaign();
</script>

<template>
    <div
        v-if="showBundleCampaign"
        class="flex flex-col gap-5 rounded bg-gray-900 p-6 text-white md:flex-row md:gap-7"
    >
        <div
            class="flex aspect-square h-[80px] w-[80px] rotate-[10deg] flex-col items-center justify-center rounded-full bg-yellow-600"
        >
            <div class="flex">
                <JamBaseText variant="xl">-10%</JamBaseText>*
            </div>
        </div>
        <div class="flex flex-col items-start gap-4">
            <div>
                <JamBaseText variant="xl">
                    {{ BUNDLE_CAMPAIGN_HEADLINE }}
                </JamBaseText>
                <JamBaseText class="mt-3">
                    {{ BUNDLE_CAMPAIGN_DESCRIPTION }}
                    <CommCampaignModal />
                </JamBaseText>
            </div>
            <JamBaseText variant="xs" class="leading-4">
                *{{ BUNDLE_CAMPAIGN_LEGAL_TEXT }}
            </JamBaseText>
        </div>
    </div>
</template>
